/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'project-contributors-picker.done': 'Listo',
  'project-contributors-picker.go-back-label': 'Volver',
  'project-contributors-picker.header': 'Seleccionar miembros del proyecto',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} miembro} other {{membersCount,number} miembros}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Seleccionar de {membersCount,number} miembro} other {Seleccionar de {membersCount,number} miembros}}',
  'project-contributors-picker.your-teams-title': 'Tus equipos',
  'project-fields.common.generic-error.description': 'Comprueba tu conexión a Internet e inténtalo de nuevo.',
  'project-fields.common.generic-error.title': 'Se ha producido un error',
  'project-fields.link-item.delete-label': 'Eliminar',
  'project-fields.link-item.edit-label': 'Editar',
  'project-fields.project-contributes-to.add-goal-title': 'Añadir meta',
  'project-fields.project-contributes-to.empty-title': 'No hay metas',
  'project-fields.project-contributes-to.title': 'Contribución a',
  'project-fields.project-contributors.add-contributors-title': 'Añadir colaboradores',
  'project-fields.project-contributors.empty-title': 'No hay colaboradores',
  'project-fields.project-contributors.remove-contributor': 'Eliminar colaborador',
  'project-fields.project-contributors.remove-contributor-error-message': 'No se ha podido eliminar al colaborador',
  'project-fields.project-contributors.remove-team': 'Eliminar equipo',
  'project-fields.project-contributors.show-more': 'Mostrar más',
  'project-fields.project-contributors.title': 'Colaboradores',
  'project-fields.project-contributors.view-profile': 'Ver perfil',
  'project-fields.project-contributors.view-profile-team': 'Ver perfil',
  'project-fields.project-focus-areas.title': 'Áreas de enfoque',
  'project-fields.project-followers.add-followers-title': 'Añadir seguidores',
  'project-fields.project-followers.empty-title': 'No hay seguidores',
  'project-fields.project-followers.title': 'Seguidores',
  'project-fields.project-link-picker.aria-label': 'Enlaces vistos recientemente',
  'project-fields.project-link-picker.invalid-link-input.error': 'Comprueba que tu enlace sea una URL válida.',
  'project-fields.project-link-picker.link-input.clear-label': 'Borrar enlace',
  'project-fields.project-link-picker.link-input.placeholder': 'Pegar enlace o buscar en vistos recientemente',
  'project-fields.project-link-picker.text-input.clear-label': 'Borrar texto',
  'project-fields.project-link-picker.text-input.placeholder': 'Texto para mostrar (opcional)',
  'project-fields.project-links.add-links-title': 'Añadir enlaces',
  'project-fields.project-links.add-links-tooltip': 'Añade enlaces a documentos, diseños y mucho más',
  'project-fields.project-links.delete-link-button': 'Eliminar enlace',
  'project-fields.project-links.edit-link-button': 'Editar enlace',
  'project-fields.project-links.empty-title': 'No hay enlaces',
  'project-fields.project-links.title': 'Enlaces',
  'project-fields.project-owner.title': 'Propietario',
  'project-fields.project-start-date.add-start-date-title': 'Añadir fecha de inicio',
  'project-fields.project-start-date.cancel-button': 'Guardar',
  'project-fields.project-start-date.creation-date': 'Este proyecto se creó el {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Edita la fecha de inicio del proyecto',
  'project-fields.project-start-date.empty-title': 'No hay fecha de inicio',
  'project-fields.project-start-date.enter-start-date-title': 'Introducir fecha de inicio',
  'project-fields.project-start-date.open-calendar-label': 'Abrir calendario',
  'project-fields.project-start-date.read-only':
    'Solo los colaboradores con acceso de edición pueden cambiar la fecha de inicio.',
  'project-fields.project-start-date.title': 'Fecha de inicio',
  'project-fields.project-state.archived': 'Archivado',
  'project-fields.project-state.at-risk': 'En riesgo',
  'project-fields.project-state.cancelled': 'Cancelado',
  'project-fields.project-state.completed': 'Completados 🎉',
  'project-fields.project-state.off-track': 'No según lo previsto',
  'project-fields.project-state.on-track': 'Según lo previsto',
  'project-fields.project-state.paused': 'En pausa',
  'project-fields.project-state.pending': 'Pendiente',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Más estados',
  'project-fields.project-status.title': 'Estado',
  'project-fields.project-tags.add-tags-title': 'Añade etiquetas',
  'project-fields.project-tags.empty-title': 'No hay etiquetas',
  'project-fields.project-tags.title': 'Etiquetas',
  'project-fields.project-target-date.picker-placeholder': 'Pendiente',
  'project-fields.project-target-date.title': 'Fecha prevista',
  'project-fields.project-work-items.show-all-non-final': 'Mostrar todo',
  'project-fields.project-work-items.show-less-non-final': 'Mostrar menos',
  'project-fields.project-work-tracked-picker.cancel-button': 'Guardar',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Añade un enlace al lugar en el que estás haciendo un seguimiento del trabajo para este proyecto',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Introduce una URL válida',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Busca actividades de Jira',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Busca o añade enlaces a los lugares en los que estás haciendo un seguimiento del trabajo para este proyecto.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Prueba a introducir de nuevo la clave de elemento de actividad o la URL de Jira, o a utilizar otros términos para buscar.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'No hemos encontrado ninguna coincidencia',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Visto recientemente',
  'project-fields.project-work-tracked-picker.results-title': 'Resultados',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Busca en Jira o añade un enlace',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Vincula este proyecto con la actividad de Jira seleccionada y mantén los detalles sincronizados automáticamente.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Ten en cuenta que todos los usuarios que puedan ver esta actividad de Jira verán los detalles de tu proyecto.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Sincronizar con Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Cancelar',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Conectar',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Selecciona los detalles que quieres usar para este trabajo de ahora en adelante:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Sincronizar este proyecto con Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Sincronización de etiquetas',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Sincronizar etiquetas de Jira con etiquetas del proyecto',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Nombre del proyecto',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Fecha de inicio',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Fecha prevista',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Enlace de seguimiento de trabajo',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Busca actividades de Jira o añade enlaces a los lugares en los que estás haciendo un seguimiento del trabajo para este proyecto.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': '¿Dónde se hace un seguimiento del trabajo?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Añadir actividades de Jira',
  'project-fields.project-work-tracked.empty-title': 'No hay actividades de Jira',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Vinculada con Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Sincronizar ahora',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Sincronizada con Jira',
  'project-fields.project-work-tracked.title': 'Trabajo en seguimiento',
  'project-fields.related-project-picker.add-button-label': 'Añadir',
  'project-fields.related-project-picker.cancel-button-label': 'Cancelar',
  'project-fields.related-project-picker.depended-by-option-label': 'El proyecto tiene como dependencia',
  'project-fields.related-project-picker.depends-on-option-label': 'El proyecto depende de',
  'project-fields.related-project-picker.empty-state-description':
    'Busca proyectos relacionados para vincularlos a este proyecto.',
  'project-fields.related-project-picker.empty-state-title': 'Buscar proyectos',
  'project-fields.related-project-picker.project-relationship-type-label':
    'Selecciona el tipo de relación del proyecto',
  'project-fields.related-project-picker.project-search-placeholder': 'Buscar proyectos',
  'project-fields.related-project-picker.related-option-label': 'El proyecto está relacionado con',
  'project-fields.related-project-picker.related-project-list-label': 'Proyectos relacionados',
  'project-fields.related-projects.add-related-title': 'Añadir proyectos relacionados',
  'project-fields.related-projects.add-related-tooltip': 'Añadir proyectos dependientes o relacionados',
  'project-fields.related-projects.dependent-by-projects-heading': 'Tiene como dependencia',
  'project-fields.related-projects.dependent-on-projects-heading': 'Depende de',
  'project-fields.related-projects.empty-title': 'No hay proyectos relacionados',
  'project-fields.related-projects.related-projects-heading': 'Relacionado con',
  'project-fields.related-projects.title': 'Relacionado',
  'project-fields.use-project-flags.generic-error-description': 'Algo ha ido mal. Inténtalo de nuevo en unos minutos.',
  'project-fields.use-project-flags.generic-error-title': 'Se ha producido un error',
  'project-fields.use-project-flags.project-links-add-failure-title': 'No se ha podido añadir el enlace',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'No se ha podido eliminar el enlace',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'No se ha podido editar el enlace',
  'project-fields.use-project-flags.project-owner-change-error-header': 'Error al cambiar el propietario del proyecto',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'No hemos podido actualizar la fecha de inicio del proyecto',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'No se ha podido añadir la etiqueta',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'No se ha podido crear la etiqueta',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'El nombre que has introducido para la etiqueta es demasiado largo. Introduce un nombre con 255 caracteres o menos.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'No se ha podido crear la etiqueta',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'No se ha podido eliminar la etiqueta',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'Error al eliminar el equipo; vuelve a intentarlo',
  'project-fields.use-project-flags.related-project-remove-failure-title':
    'No se ha podido eliminar el proyecto relacionado',
};
